import React from 'react';
import {useTranslation} from 'react-i18next';
import {Card, CardBody, Col} from 'reactstrap';
import {LocaleLink} from '@/routes';
import Separator from '@/views/shared/Separator';
import styles from '@/views/ForgetPassword/index.module.css';

const SuccessWithEmail = ({email}) => {
  const {t: tr} = useTranslation('forget_password');
  const subtr = tr('with_email');

  return (
    <Card>
      <CardBody className={styles.section}>
        <div className='text-center'>
          <br />
          <h1 className={styles.title}>{tr('title')}</h1>
          <Separator />
          <h3 className={styles.subtitle}>{subtr.sub_title}</h3>
          <br />
          <span>
            {tr('with_email.content_line1', {email})}
            <br />
            {subtr.content_line2}
          </span>
          <br />
          <br />
          <span>{subtr.content_line3}</span>
          <br />
          <span>{subtr.content_line4}</span>
          <br />
          <br />
          <Col md={{size: 6, offset: 3}}>
            <LocaleLink to='/' className='btn btn-secondary btn-lg btn-block'>
              {tr('send_again')}
            </LocaleLink>
          </Col>
        </div>
      </CardBody>
    </Card>
  );
};

export default SuccessWithEmail;
